import {useEffect, useState} from "react";
import {animated, useSpring} from "@react-spring/web";
import styles from "../marketing.module.scss";
import sec06_alphabet01_m from '../../../../resources/img/Events/Marketing/sec06_alphabet01_m.png';
import sec06_alphabet02_m from '../../../../resources/img/Events/Marketing/sec06_alphabet02_m.png';

export const Section06 = (props) => {
    const [frame, setFrame] = useState(0)
    const spring = useSpring({ x: frame })

    useEffect(() => {
        if (!props.ranges?.length || props.ranges[0].length < 2) return
        const currentFrame = props.run(props)
        // console.log(currentFrame)
        setFrame(currentFrame)
    }, [props.pageYOffset, props.innerHeight])

    return (
        <animated.div className={styles['animation-container']} style={{
            opacity: spring.x.to({
                range: props.section.opacityRange as number[],
                output: props.section.opacityOutput as number[]
            }).to(x => x),
        }}>
            <div className={`${styles.sec} ${styles.sec06} ${styles.rel}`}>
                <div className={styles.sec06__fontWrap}>
                    <animated.p className={`${styles.sec06__fontWrap__font01} ${styles.notoBold} ${styles.ab} ${styles.marginDel}`} style={{
                        opacity: spring.x.to({
                            range: [0, 0.15, 0.3, 0.85, 1],
                            output: [0, 0, 1, 1, 0]
                        }).to(x => x),
                        translateY: spring.x.to({
                            range: [0, 0.15, 0.3, 0.85, 1],
                            output: [10, 10, 0, 0, -10]
                        }).to(x => `${x}vh`)
                    }}>매 순간 쌓이도록<br></br>혜택의 구조를</animated.p>
                    <animated.p className={`${styles.sec06__fontWrap__font02} ${styles.notoBold} ${styles.ab} ${styles.marginDel}`} style={{
                        opacity: spring.x.to({
                            range: [0.95, 1.2, 2],
                            output: [0, 1, 1]
                        }).to(x => x),
                        translateY: spring.x.to({
                            range: [0.95, 1.2, 1.85, 2],
                            output: [10, 0, 0, -10]
                        }).to(x => `${x}vh`)
                    }}>확 바꿨습니다</animated.p>
                </div>
                <animated.img className={`${styles.sec06__img01} ${styles.ab}`} src={sec06_alphabet01_m} alt="알파벳 묶음1" style={{
                    translateY: spring.x.to({
                        range: [0, 0.15, 1],
                        output: [30, 0, 0]
                    }).to(x => `${x}vh`)
                }} />
                <animated.img className={`${styles.sec06__img02} ${styles.ab}`} src={sec06_alphabet02_m} alt="알파벳 묶음2" style={{
                    translateY: spring.x.to({
                        range: [0, 0.15, 1],
                        output: [-30, 0, 0]
                    }).to(x => `${x}vh`)
                }} />
                <span className={`${styles.sec06__circle01} ${styles.ab}`}></span>
                <div className={`${styles.sec06__dots} ${styles.ab}`}>
                    <div className={styles.sec06__dots__line01}>
                        <span className={`${styles.sec06__dots__line01__dot01} ${styles.dot} ${styles.dotColor02}`}></span>
                        <span className={`${styles.sec06__dots__line01__dot02} ${styles.dot} ${styles.dotColor02}`}></span>
                        <span className={`${styles.sec06__dots__line01__dot03} ${styles.dot} ${styles.dotColor02}`}></span>
                        <span className={`${styles.sec06__dots__line01__dot04} ${styles.dot} ${styles.dotColor02}`}></span>
                        <span className={`${styles.sec06__dots__line01__dot05} ${styles.dot} ${styles.dotColor02}`}></span>
                        <span className={`${styles.sec06__dots__line01__dot06} ${styles.dot} ${styles.dotColor02}`}></span>
                    </div>
                    <div className={styles.sec06__dots__line02}>
                        <span className={`${styles.sec06__dots__line02__dot01} ${styles.dot} ${styles.dotColor02}`}></span>
                        <span className={`${styles.sec06__dots__line02__dot02} ${styles.dot} ${styles.dotColor02}`}></span>
                        <span className={`${styles.sec06__dots__line02__dot03} ${styles.dot} ${styles.dotColor02}`}></span>
                        <span className={`${styles.sec06__dots__line02__dot04} ${styles.dot} ${styles.dotColor02}`}></span>
                        <span className={`${styles.sec06__dots__line02__dot05} ${styles.dot} ${styles.dotColor02}`}></span>
                        <span className={`${styles.sec06__dots__line02__dot06} ${styles.dot} ${styles.dotColor02}`}></span>
                    </div>
                </div>
            </div>
        </animated.div>
    )
}